// base component
import { PreviewComponent } from './preview.component';

// components

export const PreviewModule = angular.module('topbroker.previews', [])
  .component('preview', PreviewComponent)
  .name;
